// extracted by mini-css-extract-plugin
export default {"title":"_10fd8d4be1","bld":"_8d16e6d39f"};